'use client';

import * as React from 'react';
import { Card, CardContent } from '@mui/material';
import { Stack } from '@mui/system';

import { GameJurisdictionsTable } from '../game-jurisdictions-table';

export function GameJurisdictions({ game }: { game: any | undefined }): React.JSX.Element {
  return (
    <Stack direction="column" gap={2}>
      <Card>
        <CardContent>
          <Stack direction="column" gap={1.5}>
            {game ? <GameJurisdictionsTable gameData={{ ...game }} /> : null}
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  );
}
